/**
 * HeaderAction — a button in the header of a page that leads off the Dashboard (Chat,
 * the Run map). It is icon-only at the Touch floor in Single-pane and labelled in Split.
 */

import { ActionIcon, Button } from '@mantine/core';
import type { MantineColor } from '@mantine/core';
import type { Icon } from '@tabler/icons-react';

interface Props {
  label: string;
  icon: Icon;
  iconOnly: boolean;
  color?: MantineColor;
  loading?: boolean;
  onClick: () => void;
}

export function HeaderAction({
  label,
  icon: ButtonIcon,
  iconOnly,
  color,
  loading,
  onClick,
}: Props) {
  if (iconOnly) {
    return (
      <ActionIcon
        variant="subtle"
        color={color}
        aria-label={label}
        loading={loading}
        onClick={onClick}
      >
        <ButtonIcon size={20} />
      </ActionIcon>
    );
  }
  // A labelled header button sits at the Touch floor, so it takes the 18px icon.
  return (
    <Button
      variant="subtle"
      color={color}
      h={44}
      leftSection={<ButtonIcon size={18} />}
      loading={loading}
      onClick={onClick}
    >
      {label}
    </Button>
  );
}
